


















import Vue from 'vue'
import Component from 'vue-class-component'
import ContactRespondeco from '@/main/header/contact-respondeco.vue'
import { isRespondeco } from '@/config/environments'

@Component({
  components: { ContactRespondeco },
})
export default class UnauthenticatedUserBar extends Vue {
  public isRespondeco: boolean = isRespondeco()
}
